import { axios } from '../helpers/axios'
import { readPersistedTenantId } from '../helpers/resolve-tenant'

const brandPayload = () => {
  const brandKey = readPersistedTenantId()
  return brandKey ? { brand_key: brandKey } : {}
}

export const PasswordlessService = () => {
  const createPasswordless = async ({ email }) => {
    const resp = await axios.post(
      '/auth/create-password-less',
      { email, ...brandPayload() }
    )
    if (!resp) throw new Error('Ocurrió un error al solicitar un nuevo código')
    return resp
  }

  const verifyPasswordless = async ({ email, code }) => {
    const resp = await axios.post(
      '/auth/verify-password-less',
      {
        email,
        code,
        ...brandPayload()
      }
    )
    if (resp.data.error) throw new Error(resp.data.error)
    sessionStorage.setItem('authorizationCode', resp.data.authorizationCode)
    return resp.data
  }

  return {
    createPasswordless,
    verifyPasswordless
  }
}
